export const commonEnvironment = {
  infoDashboard: {
    title: 'Wissenszentrale für gemeinsamen Erfolg.',
  },
};
